// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"d29ffee0","70":"62fb858f","189":"2040ce00","275":"d3ebe585","437":"42d9f5fa","545":"7de299fb","805":"df88f79b"}[chunkId] + ".chunk.js";
};